<ui-loading [loading]="loading">
  <section>
    <slot name="mySelectElectricalProductLabel"></slot>
    <h2>
      <span class="product-icon">
        <slot name="mySelectElectricalProductIcon"></slot>
      </span>
      <span class="product-name" #loader>
        {{ agreementName || "aAAAaaaAAaAAAa" }}
      </span>
    </h2>
    <p class="product-description">
      <slot name="mySelectElectricalProductMainBody"></slot>
    </p>

    <p class="co2-label">
      <slot name="mySelectElectricalProductCO2Label"></slot>
      <ng-container *ngIf="estimatedCo2EmissionPerMonthUnit?.value">
        {{ estimatedCo2EmissionPerMonthUnit | unit : '1.1-1' }}
      </ng-container>
      &nbsp; 
      <ui-tooltip variant="info" position="top">
        <slot name="mySelectElectricalProductCo2Information"></slot>
      </ui-tooltip>
    </p>
    <hr>
    <section>
      <dl>
        <dt>
          <slot name="mySelectElectricalProductMonthlyBaseFeeLabel"></slot>
        </dt>
        <dd class="monthly-fee">
          <span #loader [ngClass]="{ 'strike' : isDiscountedProduct }">
            {{ (monthlyBaseFee | unit : '1.2-2') || "AAaAa" }}
          </span>
          <span class="discounted-monthly-base-fee" *ngIf="isDiscountedProduct">
            {{ discountedMonthlyBaseFee | unit : '1.2-2' }}
          </span>
        </dd>
        <ng-container *ngIf="discountLength?.value">
          <dt>
            <slot name="mySelectElectricalProductLengthOfDiscountLabel"></slot>
          </dt>
          <dd>
            <span #loader>
              {{ (discountLength | unit) ||  "AAAaaAAAaAAAA"  }}
            </span>
          </dd> 
        </ng-container>
        <ng-container *ngIf="!hideElectricityPriceRow">
          <dt>
            <slot name="mySelectElectricalProductElectricityPriceLabel"></slot>
          </dt>
          <dd>
            <span #loader> 
              <ng-container *ngIf="productType !== 'spot'">
                {{ (electricityPrice | unit : '1.2-2') }}
              </ng-container>
              <ng-container *ngIf="productType === 'spot'">
                <slot name="mySelectElectricalProductElectricityVariablePricePrefix"></slot> {{ (electricityPrice | unit : '1.2-2') }}
              </ng-container>
            </span>
          </dd>
        </ng-container>
        <ng-container *ngIf="originFee?.value">
          <dt>
            {{ energySourceName }}:
          </dt>
          <dd>
            <span #loader> 
              {{ (originFee | unit : '1.2-2') ||  "AAaaAAAA" }}
            </span>
            &nbsp;
            <ui-tooltip variant="info" position="top">
              <slot name="mySelectElectricalProductOriginFeeInformation"></slot>
            </ui-tooltip>
          </dd>
        </ng-container>
         <ng-container *ngIf="spotGuardFee?.value">
          <dt>
            <slot name="mySelectElectricalProductSpotGuardFeeLabel"></slot>
          </dt>
          <dd>
            <span #loader> 
              {{ (spotGuardFee | unit : '1.2-2') ||  "AAaaAAAA" }}
            </span>
            &nbsp;
            <ui-tooltip variant="info" position="top">
              <slot name="mySelectElectricalProductSpotGuardFeeInformation"></slot>
            </ui-tooltip>
          </dd>
        </ng-container>
        <dt>
          <slot name="mySelectElectricalProductContractLengthLabel"></slot>
        </dt>
        <dd>
          <span #loader>
            <ng-container *ngIf="productType === 'fixed'">
              <slot name="mySelectElectricalProductContractLengthProductTypeFixedLabel"></slot> {{ (contractLength | unit) ||  "AAAaaaAA" }}
            </ng-container>
            <ng-container *ngIf="(productType === 'variable') || (productType === 'spot')  " >
              <slot name="mySelectElectricalProductContractLengthProductTypeVariableLabel"></slot>
            </ng-container>
          </span>            
        </dd>
        <dt *ngIf="!isEmptySlot('mySelectElectricalProductPaymentTypeText')">
          <slot name="mySelectElectricalProductPaymentTypeLabel"></slot>
        </dt>
        <dd *ngIf="!isEmptySlot('mySelectElectricalProductPaymentTypeText')">
          <span #loader>
            <slot name="mySelectElectricalProductPaymentTypeText"></slot>
          </span>            
        </dd>
      </dl>
      <hr>
      <h3 *ngIf="!hideMonthlyCost" class="electricity-price" #loader> {{ (estimatedElectricityPricePerMonthUnit | unit:'1.2-2') ||  "aaaAAAAaAA" }}*</h3>
      <button ui-button fluid="true" size="large" [disabled]="loading" (click)="onSelected()">
        <slot name="mySelectElectricalProductChooseProductButton"></slot>
      </button>
    </section>
  </section>
</ui-loading>